"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GovernanceContainer = void 0;
var React = require("react");
var mobx_react_1 = require("mobx-react");
var buttons_1 = require("../buttons");
var App_1 = require("../../App");
var multiSelect_1 = require("../lib/multiSelect");
var mobx_1 = require("mobx");
var contexts_1 = require("../../interfaces/contexts");
var urls_1 = require("../../urls");
var generic_1 = require("../generic");
var GovernanceContainer = (function (_super) {
    __extends(GovernanceContainer, _super);
    function GovernanceContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            available_templates: [],
            available_risk_categories: [],
            available_ca_categories: [],
            template: 0,
            risk_categories: [],
            ca_categories: [],
            add_project: {
                admin: false,
                user: false,
                read_only: false,
            },
            add_category: {
                admin: false,
                user: false,
                read_only: false,
            },
            add_cacategory: {
                admin: false,
                user: false,
                read_only: false,
            },
            delete_others_comments: {
                admin: false,
                user: false,
                read_only: false,
            },
        };
        return _this;
    }
    GovernanceContainer.prototype.componentDidMount = function () {
        this.refresh();
    };
    GovernanceContainer.prototype.render = function () {
        var _this = this;
        var emptyChoice = {
            'display_name': 'None',
            'value': '0'
        };
        return (React.createElement("div", { className: "container" },
            React.createElement("h2", null, gettext("Governance")),
            React.createElement("table", { className: "table table-bordered" },
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("label", null,
                            gettext("Governing template"),
                            ":\u00A0",
                            React.createElement(generic_1.ChoiceSelect, { choices: $.merge([emptyChoice], this.state.available_templates), value: this.state.template, onChange: function (e) {
                                    var value = parseInt(e.target.value.toString());
                                    _this.setState({ template: value });
                                    _this.refresh(value);
                                } }))),
                    React.createElement("td", null),
                    React.createElement("td", { className: "text-right" },
                        React.createElement(buttons_1.PrimaryButton, { onClick: this.onSave.bind(this) }, gettext("Save")))),
                (this.state.available_risk_categories.length > 0 ||
                    this.state.available_ca_categories.length > 0) &&
                    React.createElement(React.Fragment, null,
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 3 },
                                React.createElement("h3", null, gettext("Reuse Categories & Tags")))),
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 3 },
                                React.createElement(multiSelect_1.Multiselect, { choices: this.state.available_risk_categories, name: "", value: this.state.risk_categories, noneSelectedText: gettext("Select Risk Categories"), selectedText: gettext("Risk Categories selected"), onChange: function (value) { return _this.setState({
                                        'risk_categories': value
                                    }); }, classes: "gm--fullwidth" }))),
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 3 },
                                React.createElement(multiSelect_1.Multiselect, { choices: this.state.available_ca_categories, name: "", value: this.state.ca_categories, noneSelectedText: gettext("Select Control & Action Categories"), selectedText: gettext("Control & Action Categories selected"), onChange: function (value) { return _this.setState({
                                        'ca_categories': value
                                    }); }, classes: "gm--fullwidth" })))),
                React.createElement("tr", null,
                    React.createElement("td", { colSpan: 3 },
                        React.createElement("h3", null, gettext("Role Permissions")))),
                React.createElement("tr", null,
                    React.createElement("th", null, gettext("Description")),
                    React.createElement("th", null, gettext("Project Admin")),
                    React.createElement("th", null, gettext("Project User"))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("div", null, gettext("Can create project?")),
                        React.createElement("div", null, gettext("Assuming the contract has bought enough slots for projects"))),
                    React.createElement("td", { className: "--center" },
                        React.createElement("input", { type: "checkbox", checked: this.state.add_project.admin, onChange: function (e) { return _this.setState({
                                add_project: {
                                    admin: e.target.checked,
                                    user: _this.state.add_project.user,
                                    read_only: _this.state.add_project.read_only,
                                }
                            }); } })),
                    React.createElement("td", { className: "--center" },
                        React.createElement("input", { type: "checkbox", checked: this.state.add_project.user, onChange: function (e) { return _this.setState({
                                add_project: {
                                    admin: _this.state.add_project.admin,
                                    user: e.target.checked,
                                    read_only: _this.state.add_project.read_only,
                                }
                            }); } }))),
                React.createElement("tr", null,
                    React.createElement("td", null, gettext("Can create Risk Category?")),
                    React.createElement("td", { className: "--center" },
                        React.createElement("input", { type: "checkbox", checked: this.state.add_category.admin, onChange: function (e) { return _this.setState({
                                add_category: {
                                    admin: e.target.checked,
                                    user: _this.state.add_category.user,
                                    read_only: _this.state.add_category.read_only,
                                }
                            }); } })),
                    React.createElement("td", { className: "--center" },
                        React.createElement("input", { type: "checkbox", checked: this.state.add_category.user, onChange: function (e) { return _this.setState({
                                add_category: {
                                    admin: _this.state.add_category.admin,
                                    user: e.target.checked,
                                    read_only: _this.state.add_category.read_only,
                                }
                            }); } }))),
                React.createElement("tr", null,
                    React.createElement("td", null, gettext("Can create Control & Action Category?")),
                    React.createElement("td", { className: "--center" },
                        React.createElement("input", { type: "checkbox", checked: this.state.add_cacategory.admin, onChange: function (e) { return _this.setState({
                                add_cacategory: {
                                    admin: e.target.checked,
                                    user: _this.state.add_cacategory.user,
                                    read_only: _this.state.add_cacategory.read_only,
                                }
                            }); } })),
                    React.createElement("td", { className: "--center" },
                        React.createElement("input", { type: "checkbox", checked: this.state.add_cacategory.user, onChange: function (e) { return _this.setState({
                                add_cacategory: {
                                    admin: _this.state.add_cacategory.admin,
                                    user: e.target.checked,
                                    read_only: _this.state.add_cacategory.read_only,
                                }
                            }); } }))),
                React.createElement("tr", null,
                    React.createElement("td", null, gettext("Can delete other users' comments?")),
                    React.createElement("td", { className: "--center" },
                        React.createElement("input", { type: "checkbox", checked: this.state.delete_others_comments.admin, onChange: function (e) { return _this.setState({
                                delete_others_comments: {
                                    admin: e.target.checked,
                                    user: _this.state.delete_others_comments.user,
                                    read_only: _this.state.delete_others_comments.read_only,
                                }
                            }); } })),
                    React.createElement("td", { className: "--center" },
                        React.createElement("input", { type: "checkbox", checked: this.state.delete_others_comments.user, onChange: function (e) { return _this.setState({
                                delete_others_comments: {
                                    admin: _this.state.delete_others_comments.admin,
                                    user: e.target.checked,
                                    read_only: _this.state.delete_others_comments.read_only,
                                }
                            }); } }))))));
    };
    GovernanceContainer.prototype.onSave = function () {
        var permissions = {
            add_project: this.state.add_project,
            add_category: this.state.add_category,
            add_cacategory: this.state.add_cacategory,
            delete_others_comments: this.state.delete_others_comments,
        };
        var rules = {
            risk_categories: this.state.risk_categories.map(function (x) { return parseInt(x); }),
            ca_categories: this.state.ca_categories.map(function (x) { return parseInt(x); }),
        };
        this.save({
            template_id: this.state.template,
            settings: {
                permissions: permissions,
                rules: rules,
            }
        }).then(function () {
            notification(gettext("Governance saved successfully"));
        });
    };
    GovernanceContainer.prototype.refresh = function (template_id) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ContractContext) {
                    $.get((0, urls_1.resolve)(urls_1.Urls.contract_governance_state, context.contract), template_id != undefined ? { template_id: template_id } : undefined).then(function (data) {
                        _this.setState({
                            template: data.settings.governing_template,
                            available_templates: data.choices.governing_template,
                            available_risk_categories: data.choices.risk_categories,
                            available_ca_categories: data.choices.ca_categories,
                            risk_categories: data.settings.rules.risk_categories,
                            ca_categories: data.settings.rules.ca_categories,
                            add_project: data.settings.permissions.add_project,
                            add_category: data.settings.permissions.add_category,
                            add_cacategory: data.settings.permissions.add_cacategory,
                            delete_others_comments: data.settings.permissions.delete_others_comments,
                        });
                    });
                }
                else {
                    throw new Error("GovernanceContainer does not support the current context");
                }
                return [2];
            });
        });
    };
    GovernanceContainer.prototype.save = function (governanceData) {
        return __awaiter(this, void 0, void 0, function () {
            var context;
            var _this = this;
            return __generator(this, function (_a) {
                context = App_1.store.context.get();
                if (context instanceof contexts_1.ContractContext) {
                    return [2, $.post((0, urls_1.resolve)(urls_1.Urls.contract_governance_state, context.contract), JSON.stringify(governanceData)).then(function (data) {
                            _this.setState({
                                template: data.settings.governing_template,
                                available_templates: data.choices.governing_template,
                                available_risk_categories: data.choices.risk_categories,
                                available_ca_categories: data.choices.ca_categories,
                                risk_categories: data.settings.rules.risk_categories,
                                ca_categories: data.settings.rules.ca_categories,
                                add_project: data.settings.permissions.add_project,
                                add_category: data.settings.permissions.add_category,
                                add_cacategory: data.settings.permissions.add_cacategory,
                                delete_others_comments: data.settings.permissions.delete_others_comments,
                            });
                        })];
                }
                else {
                    throw new Error("ContractState does not support the current context");
                }
                return [2];
            });
        });
    };
    __decorate([
        mobx_1.action
    ], GovernanceContainer.prototype, "refresh", null);
    __decorate([
        mobx_1.action
    ], GovernanceContainer.prototype, "save", null);
    GovernanceContainer = __decorate([
        mobx_react_1.observer
    ], GovernanceContainer);
    return GovernanceContainer;
}(React.Component));
exports.GovernanceContainer = GovernanceContainer;
